import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { PIPELINE_FULL } from '../data/roadmap';
import RoadmapTimeline from '../components/RoadmapTimeline';

export default function AdminProgressPage() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'Admin') return <Navigate to="/" replace />;

  return (
    <div style={s.wrap}>
      <h1 style={s.h1}>Progress</h1>
      <p style={s.sub}>Full roadmap including the internal Pipeline of ideas under consideration.</p>
      <RoadmapTimeline phases={PIPELINE_FULL} />
    </div>
  );
}

const s = {
  wrap: { color: 'var(--text-primary)' },
  h1:   { fontSize: '28px', fontWeight: 700, margin: '0 0 4px' },
  sub:  { color: 'var(--text-secondary)', fontSize: '14px', margin: '0 0 24px' },
};
